export const convertToGDH = ({ temperature }) => {
  //4.5 is the standard base degree value for GDH.
  const degreeTemperature = temperature - 4.5
  const gdh = degreeTemperature * 24

  return gdh
}
